import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import TopNav from "./TopNav";
import SideNav from "./SideNav";
import PageContainer from "./PageContainer";
import { adminTheme } from "../../components/admin/adminTheme";

export default function AppShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMobileNavOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!mobileNavOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileNavOpen]);

  return (
    <div className="app-shell-root">
      <style>
        {`
          .app-shell-root {
            min-height: 100vh;
            background: ${adminTheme.color.pageBg};
            color: ${adminTheme.color.text};
          }

          .app-shell-topnav {
            min-height: 76px;
            border-bottom: 1px solid ${adminTheme.color.border};
            background: rgba(255, 255, 255, 0.94);
            backdrop-filter: blur(10px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            position: sticky;
            top: 0;
            z-index: 40;
            gap: 16px;
            flex-wrap: wrap;
          }

          .app-shell-topnav__left {
            display: flex;
            align-items: center;
            gap: 14px;
            min-width: 0;
            flex: 1 1 auto;
          }

          .app-shell-topnav__label {
            color: ${adminTheme.color.textFaint};
            font-size: 0.88rem;
            font-weight: 700;
            letter-spacing: 0.02em;
            white-space: nowrap;
          }

          .app-shell-topnav__nav {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
          }

          .app-shell-layout {
            min-height: calc(100vh - 76px);
          }

          .app-shell-backdrop {
            position: fixed;
            inset: 76px 0 0 0;
            background: rgba(15, 23, 42, 0.45);
            border: none;
            opacity: 0;
            pointer-events: none;
            transition: opacity 180ms ease;
            z-index: 48;
          }

          .app-shell-backdrop.is-open {
            opacity: 1;
            pointer-events: auto;
          }

          .app-shell-sidenav {
            position: fixed;
            top: 76px;
            left: 0;
            bottom: 0;
            width: 280px;
            max-width: 86vw;
            overflow-y: auto;
            border-right: 1px solid ${adminTheme.color.border};
            background: ${adminTheme.color.surface};
            padding: 24px 16px;
            transform: translateX(-100%);
            transition: transform 180ms ease;
            z-index: 49;
            box-shadow: 0 20px 40px rgba(15, 23, 42, 0.18);
          }

          .app-shell-sidenav.is-open {
            transform: translateX(0);
          }

          .app-shell-page {
            width: 100%;
            padding: 20px;
          }

          .app-shell-page__inner {
            max-width: 1240px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          @media (min-width: 1024px) {
            .app-shell-menu-button {
              display: none !important;
            }

            .app-shell-layout {
              display: grid;
              grid-template-columns: 280px minmax(0, 1fr);
            }

            .app-shell-backdrop {
              display: none;
            }

            .app-shell-sidenav {
              position: sticky;
              top: 76px;
              transform: none;
              max-width: none;
              height: calc(100vh - 76px);
              box-shadow: none;
              z-index: 1;
            }

            .app-shell-page {
              padding: 24px;
            }
          }

          @media (max-width: 767px) {
            .app-shell-topnav {
              padding: 10px 14px;
            }

            .app-shell-topnav__label {
              display: none;
            }

            .app-shell-topnav__nav {
              width: 100%;
              justify-content: flex-start;
              padding-bottom: 6px;
            }

            .app-shell-page {
              padding: 16px;
            }
          }
        `}
      </style>

      <TopNav onMenuToggle={() => setMobileNavOpen((prev) => !prev)} />

      <div className="app-shell-layout">
        <SideNav
          mobileOpen={mobileNavOpen}
          onClose={() => setMobileNavOpen(false)}
        />

        <PageContainer>
          <Outlet />
        </PageContainer>
      </div>
    </div>
  );
}